// extracted by mini-css-extract-plugin
export default {"profile":"profileCell_profile__SdPwG","profileLink":"profileCell_profileLink__SIT7+","unassigned":"profileCell_unassigned__wwwDR"};